import Users from "../models/Users";
import UsersData from "../models/UsersData";
import {Role} from "../models/role";
import moment from "moment";
import {Url} from "../models/utils/Url";
import {generateHeaders} from "./auth-service";

export async function login(login: string, password: string) {
    localStorage.removeItem('token');
    let token = await fetch(Url.POST_LOGIN_URL, {
        method: 'POST',
        mode: "cors",
        body: JSON.stringify({"login": login, "password": password}),
        headers: {'Content-Type': 'application/json'}
    }).then(response => response.json());
    if (!token.error ) {
        await setToken(token);
        return token.user;
    }
}

export async function setToken(token: any) {
    localStorage.clear();
    localStorage.setItem('token', token.token);
    localStorage.setItem('user', JSON.stringify(token.user));
    localStorage.setItem('user_id', token.user.id);
    localStorage.setItem('user_role', token.user.role_id);
    let validity = moment().unix() + token.expires_in;
    localStorage.setItem('token_validity', validity.toString());
}

export async function getAllUsers() {
    return await fetch(Url.GET_ALL_USERS_URL, {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    })
        .then(response => response.json())
}

export async function getUserById(id: number): Promise<Users> {

    return await fetch(Url.GET_USER_SEARCH_URL.replace(Url.ARG_USER_ID, id.toString()), {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    })
        .then(response => response.json())
}

export async function getUsersByRole(role_id: number): Promise<Users[]> {
    return await fetch(Url.GET_USERS_BY_ROLE_URL.replace(Url.ARG_ROLE_ID, role_id.toString()), {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    }).then(response => response.json());
}

export async function getFullUsers(): Promise<Users[]> {
    return await fetch(Url.GET_ALL_USERS_URL, {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    }).then(response => response.json());
}

export async function getOneUserWithData(id: number): Promise<Users> {
    return await fetch('http://api.heimdall.cda5.lh.manusien-ecolelamanu.fr/api/v1/users/getOneUserWithData/' + id, {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    }).then(response => response.json());
}

export async function postUser(user: Users): Promise<Users> {
    return await fetch(Url.POST_USER_URL, {
        mode: "cors",
        method: 'POST',
        body: JSON.stringify({
            "login": user.login,
            "password": user.password,
            "password_confirmation": user.password,
            "role_id": user.role_id
        }),
        headers: generateHeaders()
    })
        .then(response => response.json())
}

export async function deleteUser(id: number) {
    return await fetch(Url.DELETE_USER_URL.replace(Url.ARG_USER_ID, id.toString()), {
        mode: "cors",
        method: 'DELETE',
        headers: generateHeaders()
    })
        .then(response => response.json()).catch(err => err);
}

export async function updateUser(user: Users) {
    return await fetch(Url.PUT_USER_URL, {
        mode: "cors",
        method: 'PUT',
        body: JSON.stringify({
            "id": user.id,
            "login": user.login,
            "role_id": user.role_id,
        }),
        headers: generateHeaders()
    })
        .then(response => response.json())
}

export async function updateOneUserPassword(user: Users) {
    return await fetch('http://api.heimdall.cda5.lh.manusien-ecolelamanu.fr/api/v1/users/password/put', {
        mode: "cors",
        method: 'PUT',
        body: JSON.stringify({
            "id": user.id,
            "password": user.password
        }),
        headers: generateHeaders()
    })
        .then(response => response.json())
}

export async function getAllRole(): Promise<Role[]> {
    return await fetch('http://api.heimdall.cda5.lh.manusien-ecolelamanu.fr/api/v1/users/getAllRole', {
        mode: "cors",
        method: 'GET',
        headers:generateHeaders()
    }).then(response => response.json());
}

// Data

export async function postUserData(data: UsersData) {
    return await fetch(Url.POST_USER_DATA_URL, {
        mode: "cors",
        method: 'POST',
        body: JSON.stringify({
            'userData_userId': data.userData_userId,
            'userData_key': data.userData_key,
            'userData_column': data.userData_column
        }),
        headers: generateHeaders()
    })
        .then(response => response.json())
}

export async function getAllUsersData() {
    return await fetch("http://api.heimdall.cda5.lh.manusien-ecolelamanu.fr/api/v1/users/data", {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    })
        .then(response => response.json())

}

export async function getOneUsersData(id: number) {
    return await fetch("http://api.heimdall.cda5.lh.manusien-ecolelamanu.fr/api/v1/users/data/" + id, {
        mode: "cors",
        method: 'GET',
        headers: generateHeaders()
    })
        .then(response => response.json())

}

export async function updateUserData(data: UsersData) {
    return await fetch(Url.PUT_USER_DATA_URL, {
        mode: "cors",
        method: 'PUT',
        body: JSON.stringify({
            'userData_id': data.userData_id,
            'userData_userId': data.userData_userId,
            'userData_key': data.userData_key,
            'userData_column': data.userData_column
        }),
        headers: generateHeaders()
    })
        .then(response => response.json())
}
